export enum ExternalSegmentTypes {
  AUTO = 'auto',
  BANKING_INVESTING = 'bankingInvesting',
  BOOKS_MAGAZINES = 'booksMagazines',
  CHARITABLE_DONORS = 'charitableDonors',
  CPG = 'cpg',
  CREDIT_DEBIT_CARDS = 'creditDebitCards',
  DEMOGRAPHICS = 'demographic',
  FINANCIALS = 'financial',
  FOOD_COOKING = 'foodCooking',
  FOOD_DRINK = 'foodDrink',
  HEALTHCARE = 'healthcare',
  HOME_REAL_ESTATE = 'homeRealEstate',
  HOUSEHOLD = 'household',
  INSURANCE = 'insurance',
  LIFESTYLES_INTERESTS = 'lifestylesInterests',
  PURCHASE_BEHAVIORS = 'purchaseBehaviors',
  PURCHASE_HISTORY = 'purchaseHistory',
  RETAIL = 'retail',
  SPORTS = 'sport',
  TECHNOLOGY_CONNECTIVITY = 'technology',
  TRAVEL = 'travel',
  BRAND = 'brandShopper',
  PLACE_VISITOR = 'placeVisitor',
  LIFESTYLE = 'lifestyle',
  INTEREST = 'interest',
  INTENT = 'purchaseIntent',
  APP_USAGE = 'mobileAppUsage',
  POLITICAL = 'political',
  TRANSACTIONAL = 'transactional',
  SEASONAL = 'seasonal',
  APPAREL = 'apparel',
  ENTERTAINMENT = 'entertainment',
  SERVICES = 'services',
  EDUCATION = 'education',
  WELLNESS = 'wellness',
}
